export default __webpack_public_path__ + "media/images/features/jtb/hero-title-cbab44bb79e8b0a79d14432cbf2d5cf0.png";